//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models

import com.tixforgigs.apax.models.FloorPlanChartSession
import com.tixforgigs.apax.models.FloorPlanExtraConfig
import com.tixforgigs.apax.models.FloorPlanMaxSelected
import com.tixforgigs.apax.models.FloorPlanPricing

        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The seats config model
* 
* @param channels the seats.io channels
* @param event the seats.io event
* @param extraConfig 
* @param holdOnSelectForGAs ...
* @param holdToken ...
* @param language Should be set by Accept-Language - default = de
* @param maxSelectedObjects key: ticketType, value: quantity
* @param pricing ...
* @param session 
* @param unavailableCategories The unavailable categories.
* @param workspaceKey ...
*/
@Serializable

data class FloorPlanConfig (


      /* the seats.io channels */
    @SerialName(value = "channels") val channels: kotlin.collections.List<kotlin.String>? = null,


      /* the seats.io event */
    @SerialName(value = "event") val event: kotlin.String? = null,


      @SerialName(value = "extraConfig") val extraConfig: FloorPlanExtraConfig? = null,


      /* ... */
    @SerialName(value = "holdOnSelectForGAs") val holdOnSelectForGAs: kotlin.Boolean? = null,


      /* ... */
    @SerialName(value = "holdToken") val holdToken: kotlin.String? = null,


      /* Should be set by Accept-Language - default = de */
    @SerialName(value = "language") val language: kotlin.String? = "de",


      /* key: ticketType, value: quantity */
    @SerialName(value = "maxSelectedObjects") val maxSelectedObjects: kotlin.collections.List<FloorPlanMaxSelected>? = null,


      /* ... */
    @SerialName(value = "pricing") val pricing: kotlin.collections.List<FloorPlanPricing>? = null,


      @SerialName(value = "session") val session: FloorPlanChartSession? = null,


      /* The unavailable categories. */
    @SerialName(value = "unavailableCategories") val unavailableCategories: kotlin.collections.List<kotlin.String>? = null,


      /* ... */
    @SerialName(value = "workspaceKey") val workspaceKey: kotlin.String? = null


) {




  }

